import apiClient from './client';

export interface Project {
  id: number;
  name: string;
}

export interface User {
  id: number;
  email: string;
  name: string;
  role: string;
  preferred_currency?: 'USD' | 'INR';
  notification_email?: string;
  last_login_at?: string;
  created_at: string;
  updated_at: string;
  projects?: Project[];
  reports_to?: number;
  reports_to_name?: string;
  is_active?: boolean;
}

export const adminApi = {
  getUsers: async (): Promise<User[]> => {
    const response = await apiClient.get<{ success: boolean; data: User[] }>('/admin/users');
    return response.data.data || [];
  },
  createUser: async (user: Partial<User> & { project_ids?: number[] }): Promise<User> => {
    const response = await apiClient.post<{ success: boolean; data: User }>('/admin/users', user);
    return response.data.data;
  },
  updateUser: async (id: number, user: Partial<User> & { project_ids?: number[] }): Promise<User> => {
    const response = await apiClient.patch<{ success: boolean; data: User }>(`/admin/users/${id}`, user);
    return response.data.data;
  },
  deleteUser: async (id: number): Promise<void> => {
    await apiClient.delete(`/admin/users/${id}`);
  },
  getSMTPSettings: async (): Promise<any> => {
    const response = await apiClient.get<{ success: boolean; data: any }>('/admin/smtp-settings');
    return response.data.data;
  },
  updateSMTPSettings: async (settings: any): Promise<any> => {
    const response = await apiClient.put<{ success: boolean; data: any }>('/admin/smtp-settings', settings);
    return response.data.data;
  },
  testSMTP: async (to: string): Promise<any> => {
    const response = await apiClient.post<{ success: boolean; data: any }>('/admin/smtp-settings/test', { to });
    return response.data;
  },
  getTeamPerformance: async (period: 'daily' | 'weekly' | 'monthly' = 'monthly', currency: 'USD' | 'INR' = 'USD'): Promise<any> => {
    const response = await apiClient.get<{ success: boolean; data: any }>(`/admin/team-performance?period=${period}&currency=${currency}`);
    return response.data.data;
  },
};
